export const featuresMarketingConverter = (props)=>{
    const { heading , features =[] , title =''  } = props.props ?? props.data ?? {};
    const header = heading?.props ?? heading?.data ?? {};
    const items = features?.map(({ content ='' , icon  })=>({
            content,
            icon: icon?.name ?? ''
        }));
    return {
        ...props,
        name: props.name ?? 'features',
        props: {
            title: {
                content: header.title ?? title
            },
            features: {
                items
            },
            variant: 'primary'
        }
    };
};

//# sourceMappingURL=converter.js.map